import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DatePickerError } from "../../features/audit-log/audit-log-types";
import { AuditLogViewModel, dateToStr } from "../../features/audit-log/audit-log-viewmodel";
import { UserIdViewModel } from "../../features/user-id/user-id-viewmodel";
import { AppRoutes } from "../../routes/routes";
import { maskUuid } from "../../utils/formatters";
import { useViewModel } from "../../viewmodel/use-view-model";
import { DateRangePicker } from "../date-range-picker";
import { renderAuditLogType } from "./audit-log-view";
export const AuditLogListView = observer(() => {
    const navigate = useNavigate();
    const vm = useViewModel(AuditLogViewModel);
    const userVM = useViewModel(UserIdViewModel);
    const { t } = useTranslation();
    const handleDetailClick = (entry) => {
        vm.setSelectedAuditEntry(entry);
        navigate(AppRoutes.AuditLogDetail.replace(":uuid", entry.id));
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: "card-body", children: _jsxs("div", { className: "card-text", children: [_jsx(DateRangePicker, { initWithRange: vm.datePickerRange, dateMin: dateToStr(vm.dateMin), dateMax: dateToStr(vm.dateMax), dateStart: dateToStr(vm.dateStart), dateEnd: dateToStr(vm.dateEnd), onRangeSelect: (pickerRange, dateStart, dateEnd) => {
                            const errResult = vm.setSelectedDate(pickerRange, dateStart, dateEnd);
                            if (errResult) {
                                handleDatesError(errResult, t);
                            }
                            else {
                                // no error, now fetch audit log for user
                                void vm.getAuditLog(userVM.userId);
                            }
                        } }), _jsxs("div", { children: [vm.auditLog.length === 0 &&
                                _jsxs("div", { className: "pt-3", children: [_jsx("h5", { children: t("auditLog.error.nothingFound", { userId: userVM.userId }) }), _jsx("p", { children: t("auditLog.error.tryChangeDate") })] }), vm.auditLog.length > 0 &&
                                _jsxs("table", { className: "table table-hover table-borderless", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t("auditLog.detail.id") }), _jsx("th", { children: t("auditLog.detail.message") }), _jsx("th", { children: t("auditLog.detail.type") })] }) }), _jsx("tbody", { children: vm.auditLog.map((entry) => renderAuditEntryRow(entry, handleDetailClick)) })] })] })] }) }) }));
});
function handleDatesError(err, t) {
    switch (err) {
        case DatePickerError.MissingDate:
            alert(t("dateRangePicker.error.missingDate"));
            break;
        case DatePickerError.MaxMonthRange:
            alert(t("dateRangePicker.error.maxMonthDateRange"));
            break;
        case DatePickerError.SwitchedStartEnd:
            alert(t("dateRangePicker.error.switchedStartEnd"));
            break;
    }
}
function renderAuditEntryRow(entry, detailClickHandler) {
    return (_jsxs("tr", { className: "align-middle", style: { cursor: "pointer" }, onClick: () => detailClickHandler(entry), children: [_jsx("td", { className: "font-monospace pt-3 pb-3", children: maskUuid(entry.id) }), _jsx("td", { className: "pt-3 pb-3 text-wrap", children: entry.message }), _jsx("td", { className: "pt-3 pb-3", children: renderAuditLogType(entry.type) })] }, entry.id));
}
